import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { vueConfig } from './config'
import { sync } from 'vuex-router-sync'
import SvgUse from '@/components/common/SvgUse'
import SeoHeading from '@/components/common/SeoHeading'
import { getImageAlt } from '@/seo'
import { platform } from '@/utils'
import smoothScroll from 'smoothscroll-polyfill'
import VueMeta from 'vue-meta'
import { initTypography } from '@/utils/typography'
import { imageAttrs, imageSrcset } from '@/utils/responsiveImages'

import 'swiper/css/swiper.min.css'
import '@/styles/index.scss'

smoothScroll.polyfill()

Vue.component('svg-use', SvgUse)
Vue.component('SeoHeading', SeoHeading)
Vue.use(VueMeta)

Object.assign(Vue.config, vueConfig)

sync(store, router)

Vue.prototype.$platform = platform()
Vue.prototype.$imageAttrs = imageAttrs
Vue.prototype.$imageSrcset = imageSrcset
Vue.prototype.$imageAlt = function (number, path = this.$route.path) {
  return getImageAlt(path, number)
}

const app = new Vue({
  router,
  store,
  render: (h) => h(App)
})

router.onReady(async () => {
  // The static HTML paints with inline CSS. Widgets measure their layout only
  // once the complete stylesheets are available.
  await Promise.all([...document.querySelectorAll('link[rel="preload"][as="style"]')].map(link => {
    return new Promise(resolve => {
      link.addEventListener('load', resolve, { once: true })
      link.addEventListener('error', resolve, { once: true })
      link.rel = 'stylesheet'
    })
  }))
  if (window.__PRERENDER__) {
    window.__PRERENDER_SCRIPTS__ = performance.getEntriesByType('resource').map(entry => entry.name)
  }
  app.$mount('#app')
  initTypography(app.$el)

  if (window.__PRERENDER__) {
    Vue.nextTick(() => {
      requestAnimationFrame(() => {
        window.__PRERENDER_READY__ = router.currentRoute.path
      })
    })
  }
})
